import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUserFromGoogle } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        // Extract session_id from URL hash
        const hash = location.hash;
        const sessionId = hash.includes('session_id=')
          ? hash.split('session_id=')[1]?.split('&')[0]
          : null;

        if (!sessionId) {
          toast.error('Sessione non valida');
          navigate('/login', { replace: true });
          return;
        }

        // Exchange session_id for user data
        const response = await fetch(
          'https://demobackend.emergentagent.com/auth/v1/env/oauth/session-data',
          {
            method: 'GET',
            headers: {
              'X-Session-ID': sessionId,
            },
          }
        );

        if (!response.ok) {
          throw new Error('Errore durante l\'autenticazione');
        }

        const data = await response.json();

        // Send to our backend to create/update user and get JWT
        const backendUrl = process.env.REACT_APP_BACKEND_URL;
        const backendResponse = await fetch(`${backendUrl}/api/auth/google`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: data.email,
            name: data.name,
            picture: data.picture,
            google_id: data.id,
            session_token: data.session_token,
          }),
        });

        if (!backendResponse.ok) {
          throw new Error('Errore nel backend');
        }

        const { token, user, store_slug } = await backendResponse.json();

        // Save token and user
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));
        
        if (store_slug) {
          localStorage.setItem('storeSlug', store_slug);
        }

        // Update auth context
        setUserFromGoogle(user);

        toast.success(`Benvenuto, ${user.name}!`);

        // Navigate based on role
        setTimeout(() => {
          switch (user.role) {
            case 'ADMIN_PLATFORM':
              navigate('/admin/platform', { replace: true });
              break;
            case 'ADMIN_STORE':
              navigate('/admin/store', { replace: true });
              break;
            case 'BARBER':
              navigate('/dashboard/barber', { replace: true });
              break;
            default:
              navigate('/dashboard', { replace: true });
          }
        }, 100);
      } catch (error) {
        console.error('Auth error:', error);
        toast.error(error.message || 'Errore durante l\'autenticazione');
        navigate('/login', { replace: true });
      }
    };

    processSession();
  }, [location, navigate, setUserFromGoogle]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="spinner mx-auto mb-4" />
        <p className="text-muted-foreground">Autenticazione in corso...</p>
      </div>
    </div>
  );
}
